import { ReactComponent as Icon } from "../images/time.svg";

const TimeIcon  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default TimeIcon;
